
















































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {PopMenuItemInterface} from '../../../common-vue-components';
import SeverityIcon from '../SeverityIcon/SeverityIcon.vue';
import { DEFAULT_SEVERITIES } from '../SeverityIcon/SeverityModel';
import SeverityInterface from '../SeverityIcon/SeverityInterface';

@Component({
    name:'PopMenu',
    components: {
        SeverityIcon,
    },
})
export default class PopMenu extends Vue {
    /**
    * Array of items to display in pop menu
    */
    @Prop(Array)
    public readonly popMenu?: PopMenuItemInterface[];
    @Prop(Boolean)
    public readonly showToolTips?: boolean;
    /**
    * Username to display at account icon
    */
    @Prop(String)
    public readonly userName?: string;
    /**
    * Flag to open menu programmatically
    */
    public menuOpened: boolean = false;
    public pop_menu_key: string = 'key';
    public severities: SeverityInterface = DEFAULT_SEVERITIES;
    public processMenu(): void {
        this.menuOpened = !this.menuOpened;
    }
    public isVisible(option: any) {
        if (option === null || option === undefined) {
            return true;
        } else {
            return option;
        }
    }
    public profileNot() {
        let count: number = 0;
        const highestSeverityNot: any = {weight:0,color:'#d12021'};
        const pmArr: any = this.popMenu as any;
        for (const element of pmArr) {
            if (!!element.notification && (!!element.notification.text || !!element.notification.severity)) {
                if (!highestSeverityNot.severity && !highestSeverityNot.text) {
                    if (!!element.notification.severity) {
                        highestSeverityNot.severity = element.notification.severity;
                        highestSeverityNot.weight = this.severities[element.notification.severity].weight;
                    } else if (!!element.notification.text) {
                        highestSeverityNot.text = element.notification.text;
                        highestSeverityNot.color = element.notification.color;
                        highestSeverityNot.weight = 0;
                    }
                } else if (highestSeverityNot.severity || highestSeverityNot.text) {
                    if (!!element.notification.severity  && (this.severities[element.notification.severity].weight > highestSeverityNot.weight)) {
                        highestSeverityNot.severity = element.notification.severity;
                        highestSeverityNot.weight = this.severities[element.notification.severity].weight;
                    }
                }
                count++;
                if(element.notification.severity && this.severities[element.notification.severity].weight > highestSeverityNot.weight ) {
                    highestSeverityNot.weight = this.severities[element.notification.severity].weight;
                }
            }
            // If there is more than one notification, display the count and use the highest severity color
            if (count > 1) {
                // Change the general color to the severity color if the highest notification is a severity icon
                if (highestSeverityNot.severity) {
                    highestSeverityNot.color = this.severities[highestSeverityNot.severity].color;
                }
                highestSeverityNot.text = count.toString();
                highestSeverityNot.tooltip = 'multiple notifications';
            }
        }
        if (count === 1) {
            // Change the profile text to 1 if only 1 text alert
            if (highestSeverityNot.text) {
                highestSeverityNot.text = '1';
            }
        }
        return highestSeverityNot;
    }
    public broadcast(item: any) {
        const e = item.title;
        this.$emit(e.toLowerCase());
        if (item.notification && item.notification.dont_clear_on_click) {
            // Do nothing
        } else {
            item.notification = {};
        }
        setTimeout(() => {
            this.pop_menu_key += 'y';
        },1000);
    }

}
